import Utils = require("../utils");
import Portal = require("portal-gis");

function isVisible(layer: Portal.MapLayerLeaf) {
    return false !== Utils.extend(layer).visible;
}

function isClosed(layer: Portal.MapLayerLeaf) {
    return true === Utils.extend(layer).expandoClosed;
}

function isLoading(layer: Portal.MapLayerLeaf) {
    return Utils.extend(layer).loading || (layer.Layers && layer.Layers.Layers.some(isLoading));
}

let renderLayer = (item: Portal.MapLayerLeaf) => {
    // do not render basemaps
    if (item.basemap) return "";

    let childMarkup = "";
    if (item.Layers) {
        childMarkup = renderLayers({ items: item.Layers.Layers });
    }

    return `
    <div class="layer layer-${item.id} ${isLoading(item) ? "loading" : ""}">
    <input id="${item.id}" type="checkbox" ${isVisible(item) ? "checked" : ""} value="${item.id}"/>
    <label class="layer-label ${childMarkup ? ("expando " + (isClosed(item) ? "closed " : "")) : ""}">${item.text}</label>
    <div class="layer-view">${childMarkup}</div>
    </div>
`;
};

function renderLayers(data: { items: Portal.MapLayerLeaf[] }) {
    return data.items.map(renderLayer).join("");
};

export = renderLayers;